import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { CustomButton } from "@/components/Button";
import { PropertyEditHistoryRow } from "@/components/property_edit/PropertyEditHistoryRow";
import { RegistrationContext } from "@/components/property_registration/RegistrationContext";

interface Props {
  contents: { label: string; value: string }[];
  editLabel?: string;
  preserveLabels?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
}

export const EditPropertyHistoryItem: React.FC<Props> = ({
  contents,
  onEdit,
  onDelete,
  editLabel = "編集",
  preserveLabels,
}) => {
  const v2 = React.useContext(RegistrationContext);
  if (!v2)
    return (
      <Box>
        {contents.map((item, i) => (
          <Box key={i}>
            <Typography>{item.label}</Typography>
            <Typography>{item.value}</Typography>
          </Box>
        ))}
        {onEdit && (
          <CustomButton type="button" onClick={onEdit}>
            {editLabel}
          </CustomButton>
        )}
        {onDelete && (
          <CustomButton type="button" onClick={onDelete}>
            削除
          </CustomButton>
        )}
      </Box>
    );
  if (preserveLabels)
    return (
      <>
        {contents.map((item) => (
          <PropertyEditHistoryRow key={item.label} label={item.label} value={item.value} onClick={onEdit} />
        ))}
      </>
    );
  return (
    <PropertyEditHistoryRow
      label={contents[0]?.value || "履歴"}
      value={contents
        .slice(1)
        .map((item) => item.value)
        .join("・")}
      onClick={onEdit}
    />
  );
};
